import React from 'react';
import { formatMoney, DEAL_LABEL } from './Markets';

const signed = (v) => (v != null && v < 0 ? 'text-red-600' : '');

// Annual figures and recent deal filings for a listed company. `finance` is
// null for companies we do not read from EDGAR, so render nothing.
export default function CompanyFinance({ finance }) {
  if (!finance) return null;
  const { years = [], deals = [] } = finance;

  return (
    <section className="mb-10" aria-label="Finance">
      <h3 className="text-lg font-semibold text-gray-900 mb-5">Finance</h3>

      {years.length > 0 && (
        <div className="overflow-x-auto border border-gray-200 rounded-xl">
          <table className="w-full text-sm">
            <thead>
              <tr className="text-left text-xs uppercase tracking-wide text-gray-400 border-b border-gray-100">
                <th className="px-4 py-3">Year end</th>
                <th className="px-4 py-3 text-right">Revenue</th>
                <th className="px-4 py-3 text-right">Operating income</th>
                <th className="px-4 py-3 text-right">Net income</th>
              </tr>
            </thead>
            <tbody>
              {years.map((y) => (
                <tr key={y.period_end} className="border-b border-gray-50 last:border-0">
                  <td className="px-4 py-3 text-gray-700">
                    {y.period_end}{' '}
                    {y.source_url && (
                      <a href={y.source_url} target="_blank" rel="noopener noreferrer"
                         className="text-xs text-videbits-700 hover:underline">filing</a>
                    )}
                  </td>
                  <td className="px-4 py-3 text-right tabular-nums">{formatMoney(y.revenue)}</td>
                  <td className={`px-4 py-3 text-right tabular-nums ${signed(y.operating_income)}`}>
                    {formatMoney(y.operating_income)}
                  </td>
                  <td className={`px-4 py-3 text-right tabular-nums ${signed(y.net_income)}`}>
                    {formatMoney(y.net_income)}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}

      {deals.length > 0 && (
        <>
          <h4 className="text-xs uppercase tracking-wide text-gray-400 mt-6 mb-2">Recent deal filings</h4>
          <ul className="border border-gray-200 rounded-xl divide-y divide-gray-50">
            {deals.map((d) => (
              <li key={`${d.event_date}-${d.source_url}`} className="px-4 py-3 text-sm">
                <div className="flex flex-wrap items-baseline justify-between gap-x-3">
                  <span className="font-medium text-gray-900">{DEAL_LABEL[d.kind] || d.kind}</span>
                  <span className="text-gray-500">{d.event_date}</span>
                </div>
                <div className="text-xs text-gray-400">
                  {d.description}{' '}
                  <a href={d.source_url} target="_blank" rel="noopener noreferrer"
                     className="text-videbits-700 hover:underline">filing</a>
                </div>
              </li>
            ))}
          </ul>
        </>
      )}

      <p className="text-xs text-gray-400 mt-3">
        Figures from {finance.source || 'SEC EDGAR'} 10-K and 8-K filings, in US dollars. Deal amounts are not shown.
        VideBits gives information, not investment advice.
      </p>
    </section>
  );
}
